import { createContext, useContext, useMemo, useState } from "react";
import {
  formatFinancialYearLabel,
  formatFinancialYearPeriodRange,
  getFinancialYearDropdownOptions,
  readStoredFinancialYearStartYear,
  storeFinancialYearStartYear,
} from "../utils/financialYear";

const FinancialYearContext = createContext(null);

export function FinancialYearProvider({ children }) {
  const [fyStartYear, setFyStartYearState] = useState(() => readStoredFinancialYearStartYear());

  const setFyStartYear = (startYear) => {
    const sy = Math.round(Number(startYear));
    if (!Number.isFinite(sy)) return;
    storeFinancialYearStartYear(sy);
    setFyStartYearState(sy);
  };

  const value = useMemo(() => {
    const options = getFinancialYearDropdownOptions(fyStartYear);
    return {
      fyStartYear,
      setFyStartYear,
      fyLabel: formatFinancialYearLabel(fyStartYear),
      periodRange: formatFinancialYearPeriodRange(fyStartYear),
      options,
    };
  }, [fyStartYear]);

  return <FinancialYearContext.Provider value={value}>{children}</FinancialYearContext.Provider>;
}

export function useFinancialYear() {
  const ctx = useContext(FinancialYearContext);
  if (!ctx) {
    const fyStartYear = readStoredFinancialYearStartYear();
    return {
      fyStartYear,
      setFyStartYear: storeFinancialYearStartYear,
      fyLabel: formatFinancialYearLabel(fyStartYear),
      periodRange: formatFinancialYearPeriodRange(fyStartYear),
      options: getFinancialYearDropdownOptions(fyStartYear),
    };
  }
  return ctx;
}
